import { makeStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  loadingShadingMui: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, .3)',
    zIndex: '9999',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  loadingIconMui: {
    position: 'absolute',
    top: 'calc(45% - 10px)',
    left: 'calc(50% - 10px)',
  },
}));

function TableActionLoading() {
  const classes = useStyles();

  return (
    <div className={classes.loadingShadingMui}>
      <CircularProgress className={classes.loadingIconMui} />
    </div>
  );
}

export default TableActionLoading;
